<template>
  <ubi-panel>
    <ubi-form-group :title="$t('posts.certificationsAndLabelsTitle')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_hqe">
            <span v-if="isEspacil">
              NF Habitat HQE
            </span>
            <span v-else>
              {{ $labels.label_hqe }}
            </span>
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_nf_maison_individuelle">
            <span v-if="isEspacil">
              NF Habitat
            </span>
            <span v-else>
              {{ $labels.label_nf_maison_individuelle }}
            </span>
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_he">
            {{$labels.label_he}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_thpe">
            {{$labels.label_thpe}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_hpe_enr">
            {{$labels.label_hpe_enr}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_bbc">
            {{$labels.label_bbc}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_he_effinergie">
            {{$labels.label_he_effinergie}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.re_2020">
            {{$labels.re_2020}}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.plan_local_habitat">
            {{ $labels.plan_local_habitat }}
          </el-checkbox>
        </el-col>
        <el-col :span="12" v-if="showRe2025">
          <el-checkbox false-label="non" true-label="oui" v-model="post.re_2025">
            {{ $labels.re_2025 }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_biodivercity">
            {{ $labels.label_biodivercity }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_biosource_niveau_1">
            {{ $labels.label_biosource_niveau_1 }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.label_biosource_niveau_2">
            {{ $labels.label_biosource_niveau_2 }}
          </el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-checkbox false-label="non" true-label="oui" v-model="post.re_seuil_2028">
            {{ $labels.re_seuil_2028 }}
          </el-checkbox>
        </el-col>
      </el-row>
    </ubi-form-group>
  </ubi-panel>
</template>
<script lang="ts">

import { mapGetters } from 'vuex'
import UbiPanel from '../../../../components/Panel.vue'
import UbiFormGroup from '@/components/forms/FormGroup.vue'

export default {
  name: 'LabelsAndCertifications',
  components: { UbiFormGroup, UbiPanel },
  props: ['post'],
  computed: {
    ...mapGetters(['getSitimmoUser', 'isPromoteur', 'isCmiste', 'isBailleurSocial']),
    isEspacil () {
      return this.getSitimmoUser && this.getSitimmoUser.id == '353182'
    },
    isProgramType () {
      const typeObjet = Number(this.post && this.post.typeObjet)
      return typeObjet >= 3000 && typeObjet < 4000
    },
    showRe2025 () {
      return this.isEspacil || this.isPromoteur || this.isCmiste || (this.isBailleurSocial && this.isProgramType)
    }
  }
}
</script>
